import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
/* eslint-disable import/no-duplicates */
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

// components
import ChatBubble from 'eCoach/ChatBubble';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Box from '@mui/material/Box';

// styles
import * as Buttons from 'theme/components/Buttons.style';
import * as StyledPromptControls from 'eCoach/_styles/PromptControls.style';
import * as Text from 'theme/components/Text.style';

interface WarningLetterSingleDateInputProps {
  sendUserInput: (text: string, type: number) => void;
  inputType: number;
}

export default function WarningLetterSingleDateInput({
  sendUserInput,
  inputType,
}: WarningLetterSingleDateInputProps): JSX.Element {
  const { t, i18n } = useTranslation('pageEcoach');
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  // Get current locale
  const locale = i18n.language === 'fr' ? fr : undefined;

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };

  const handleSubmit = () => {
    if (selectedDate) {
      // Format date based on current locale
      const formattedDate =
        i18n.language === 'fr'
          ? format(selectedDate, 'd MMM yyyy', { locale: fr })
          : format(selectedDate, 'MMM d yyyy');

      sendUserInput(formattedDate, inputType);
    }
  };

  return (
    <ChatBubble sentByUser>
      <StyledPromptControls.InputGroup>
        <Text.P2>{t('Please select a date for the incident')}</Text.P2>

        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          adapterLocale={locale}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2 }}>
            <DatePicker
              value={selectedDate}
              onChange={handleDateChange}
              slotProps={{ textField: { fullWidth: true } }}
              maxDate={new Date()}
            />
          </Box>
        </LocalizationProvider>

        <Buttons.SecondaryDark
          onClick={handleSubmit}
          inactive={!selectedDate}
          small
          stretch
        >
          {t('Submit')}
        </Buttons.SecondaryDark>
      </StyledPromptControls.InputGroup>
    </ChatBubble>
  );
}
